import {SendOutlined} from '@ant-design/icons';
import {Button, Form, Input, InputNumber, Modal} from 'antd';
import {inject, observer} from 'mobx-react';
import React, {useState} from 'react';

const TransferForm = (props) => {
  const [form] = Form.useForm();
  const [isOpen, setOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSubmitting(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await store.transactions.transfer(values);
      handleClose();
    } catch (error) {
      setSubmitting(false);
      form.setFields([
        {
          name: 'address',
          value: values.address,
          errors: [error]
        }
      ]);
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} block size="large">
        <SendOutlined /> Send
      </Button>
      <Modal
        title="New transfer"
        visible={isOpen}
        onCancel={handleClose}
        footer={[
          <Button
            key="back"
            onClick={form.submit}
            type="primary"
            block
            size="large"
            loading={isSubmitting}>
            <SendOutlined /> Send
          </Button>
        ]}>
        <Form onFinish={handleSubmit} form={form} layout="vertical">
          <Form.Item
            label="Email"
            name="address"
            rules={[
              {required: true, message: 'Email is required'},
              {type: 'email', message: 'Please provide a valid email'}
            ]}>
            <Input size="large" type="email" />
          </Form.Item>
          <Form.Item
            label="Amount"
            name="amount"
            rules={[{required: true, message: 'Amount is required'}]}>
            <InputNumber size="large" style={{width: '100%'}} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
const connectedForm = inject('store')(observer(TransferForm));

export default connectedForm;
